import { createRouter, createWebHashHistory } from 'vue-router'
import { WelcomeIndex } from '@pages/welcome'
import { AbiturientIndex, AbiturientFormNew, AbiturientFormEdit, AbiturientApplicationShow } from '@pages/abiturient'
import { KindsIndex } from '@pages/kinds'
import { ContactsPage } from '@pages/admin'
import { PermissionsIndex } from '@pages/permissions'
import { SecretaryIndex, SecretaryShow, SecretaryApplicationShow } from '@pages/secretary'
import { APPLICATION_SECTIONS_REGEX } from '@widgets/application-profile'

const routes = [
  { path: '/', name: 'root', component: WelcomeIndex },

  //abiturient routes
  { path: '/abiturient/kinds', name: 'kinds.index', component: KindsIndex, meta: { requiresAuth: true } },
  { path: '/abiturient', redirect: '/abiturient/form', name: 'abiturient.root', meta: { requiresAuth: true, requiresForm: true } },
  { path: '/abiturient/:tab(form|applications|exams|contest_list)', name: 'abiturient.index', component: AbiturientIndex, meta: { requiresAuth: true, requiresForm: true } },
  { path: '/abiturient/form/new', name: 'abiturient.form.new', component: AbiturientFormNew, meta: { requiresAuth: true } },
  { path: '/abiturient/form/edit', name: 'abiturient.form.edit', component: AbiturientFormEdit, meta: { requiresAuth: true, requiresForm: true } },

  //abiturient applications
  { path: '/abiturient/applications/:id', redirect: to => `/abiturient/applications/${to.params.id}/info` },
  { path: `/abiturient/applications/:id/:section(${APPLICATION_SECTIONS_REGEX})`, name: 'abiturient.application', component: AbiturientApplicationShow, meta: { requiresAuth: true } },

  //admin routes
  { path: '/admin', name: 'admin.index', component: PermissionsIndex, meta: { requiresAdmin: true } },
  { path: '/admin/contacts', name: 'admin.contacts', component: ContactsPage, meta: { requiresAdmin: true } },

  //secretary routes
  { path: '/secretary', name: 'secretary.index', component: SecretaryIndex, meta: { requiresSecretary: true } },
  { path: '/secretary/forms/:id', redirect: to => `/secretary/forms/${to.params.id}/form` },
  { path: '/secretary/forms/:id/:tab(form|applications|exams|contest_list)', name: 'secretary.form', component: SecretaryShow, meta: { requiresSecretary: true } },

  //secretary applications
  { path: '/secretary/forms/:formId/applications/:applicationId', redirect: to => `/secretary/forms/${to.params.formId}/applications/${to.params.applicationId}/info` },
  { path: `/secretary/forms/:formId/applications/:applicationId/:section(${APPLICATION_SECTIONS_REGEX})`, name: 'secretary.application', component: SecretaryApplicationShow, meta: { requiresSecretary: true } },

  { path: '/sidekiq', component: { template: '' }, beforeEnter: () => { window.location.href = '/sidekiq' } },
  { path: '/:pathMatch(.*)*', component: { template: '' }, beforeEnter: () => { window.location.href = '/404' } },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach((to) => {
  const user = window.gon?.user || {}

  if (to.name === 'root') {
    if (user.is_admin)     return { name: 'admin.index' }
    if (user.is_secretary) return { name: 'secretary.index' }
    if (user.id)           return { name: 'abiturient.root' }
    return
  }

  if (to.meta.requiresAdmin && !user.is_admin) return { name: 'root' }
  if (to.meta.requiresSecretary && !user.is_secretary) return { name: 'root' }
  if (to.meta.requiresAuth && !user.id) return { name: 'root' }

  if (to.meta.requiresForm && !user.is_form_exist) return { name: 'kinds.index' }
})

export default router
